import React from "react";
import "../styles/PageContent2.scss";

const PageContent2 = ({bg,title,content,color}) => {
    const style = {
        backgroundImage: `url(${bg})`,
        color:color,
      };
  return (
    <div className="main-container" style={style}>
        <div className="child-container">
          <div className="title">{title}</div>
          <div className="contentPg">{content}
          </div>
        </div>
    </div>
  );
};

export default PageContent2;
